import gql from 'graphql-tag';
import {useLazyQuery} from '@apollo/client';
import Address from "../../types/address";

const QUERY = gql`
  query getTaxJarValidatedAddresses($address: CustomerAddressInput!) {
    taxJarValidatedAddresses(address: $address) {
      attention
      company
      address1
      address2
      county
      city
      state
      postalCode
      country
      phone
      email
    }
  }
`;

const useTaxJarValidatedAddresses = (onCompleted: (data: any) => void) => {
  const [getTaxJarValidatedAddresses, { data, loading, error }] = useLazyQuery(QUERY, { onCompleted });

  if (loading) {
    return [];
  }

  if (error) {
    console.error(error);
    return [];
  }

  return data ?
    [(address: Address) => getTaxJarValidatedAddresses({ variables: { address } }), data.taxJarValidatedAddresses] :
    [(address: Address) => getTaxJarValidatedAddresses({ variables: { address } })];
};

export default useTaxJarValidatedAddresses;
